'use strict';

var processInclude = require('base/util');

$(document).ready(function () {
    processInclude(require('./product/wishlist'));
    processInclude(require('./wishlist/wishlist'));
    processInclude(require('./wishlist/shareWishlistModal'));
});
